<template>
    <modal id="answer-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('answer')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.ANSWER'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('question')"
                        list-value-field="question_text"
                        :chooseLabel="$t('question')"
                        v-model="formData.question_id"
                        :required="true"
                        :error-message="$errorMessage(errors, 'question_id')"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_QUESTION}`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('answers.answer_text')"
                        type="textarea"
                        v-model="formData.answer_text"
                        :placeholder="$placeholder('answers.answer_text')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'answer_text')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('answers.is_correct')"
                        type="single-checkbox"
                        v-model="formData.is_correct"
                        :required="false"
                        :error-message="$errorMessage(errors, 'is_correct')"
                    />
                </div>
            </div>
            <div class="form-group mb-0">
                <label>
                    {{ $t('attachments') }}
                </label>
                <app-input
                    type="dropzone"
                    v-model="attachments"
                    :error-message="errorMessageInArray(errors, 'attachments.0')"
                />
                <small class="text-muted">{{ $t('leave_attachment_allowed_file_types') }}</small>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_SELECTABLE_QUESTION} from "../../../../Config/ApiUrl";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "AnswerCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                question_id: '',
                answer_text: '',
                is_correct: 0,
            },
            TENANT_SELECTABLE_QUESTION,
            attachments: [],
        };
    },
    computed: {
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData.is_correct = formData.is_correct ? 1 : 0;
            formData = formDataAssigner(new FormData, formData);
            let url = this.apiUrl.ANSWER;
            // Remove unwanted fields
            this.attachments.forEach(file => {
                formData.append('attachments[]', file)
            })
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#answer-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'answer-table');
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#answer-modal').modal('hide');
            this.toastAndReload(data.message, 'answer-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
